import 'whatwg-fetch';

document.addEventListener("DOMContentLoaded", function() {
    let lastUpdate = 0;

    fetch("/changes.php").then(response => {
        return response.json();
    }).then(response => {
        lastUpdate = response;
    });

    let interval = setInterval(function () {
        fetch("/changes.php").then(response => {
            return response.json();
        }).then(response => {
            if(response > lastUpdate) {
                clearInterval(interval);

                setTimeout(function() {
                  location.reload(true);
                }, 1000);
            }
        });
    }, 1000);
});
